import ImageWithText from 'components/common/ImageWithText';
import RoundedButton from 'components/RoundedButton';
import { NextRouter } from 'next/router';
import { ASSET_PREFIX } from 'utils/constants';

const EmptyPrize = ({ router }: { router: NextRouter }) => {
  const addPrize = () => {
    router.push('/prizes');
  };
  return (
    <button onClick={addPrize}>
      <ImageWithText
        imageSrc={`${ASSET_PREFIX}/images/common/add-prize.svg`}
        textChildren={
          <RoundedButton
            colorStyle="OutlineDark"
            onClick={addPrize}
            rebrandDm2025
            mini
          >
            ADD PRIZE
          </RoundedButton>
        }
      />
    </button>
  );
};

export default EmptyPrize;
